import { InjectionToken } from "@angular/core";
import { IDictionaryResolverService } from "./i-dictionary-resolver-service";

export const dictionaryResolverServiceInjectionToken: InjectionToken<IDictionaryResolverService> =
  new InjectionToken<IDictionaryResolverService>('digital-signage.user-dashboard.dashboard-web.DictionaryResolverService');
